import { render, staticRenderFns } from "./CostBearerPaymentsByUnpaidInvoices.vue?vue&type=template&id=cbcb684c&scoped=true"
import script from "./CostBearerPaymentsByUnpaidInvoices.vue?vue&type=script&lang=ts"
export * from "./CostBearerPaymentsByUnpaidInvoices.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbcb684c",
  null
  
)

export default component.exports